// NOTE: Zendesk doesn't use enums, but rather strings.

import { TICKET_CATEGORIES } from 'constants/zendesk';

export const CHATCREATE_BOT_ID = '4409';
export const CHATCREATE_SESSION_STORAGE_KEY = `chatcreate_chat_id_${CHATCREATE_BOT_ID}`;

export const CATEGORY_OPTIONS = [
  {
    value: TICKET_CATEGORIES.GENERAL,
    title: 'Question about how Loom works',
  },
  {
    value: TICKET_CATEGORIES.TECHNICAL,
    title: 'Technical issues and bugs',
  },
  { value: TICKET_CATEGORIES.ACCOUNT, title: 'My Loom account' },
  { value: TICKET_CATEGORIES.BILLING, title: 'Billing, payment, pricing' },
  {
    value: TICKET_CATEGORIES.FEATURE_REQUEST,
    title: 'Product suggestions and feature requests',
  },
  { value: TICKET_CATEGORIES.OTHER, title: 'Other' },
];

export const GENERAL_OPTIONS = [
  { title: 'Plans available', value: 'hiw_plans' },
  { title: 'Recording a video', value: 'hiw_recording_a_video' },
  { title: 'Sharing my video', value: 'hiw_sharing_my_video' },
  {
    title: 'Video privacy and security',
    value: 'hiw_privacy_and_security',
  },
  {
    title: 'Managing my video (editing, archiving, deleting)',
    value: 'hiw_managing_my_video',
  },
  { title: 'Features available', value: 'hiw_features_available' },
  {
    title: 'My account and profile settings',
    value: 'hiw_account_profile_settings',
  },
  {
    title: 'Installing Loom (app, extension, mobile)',
    value: 'hiw_installing_loom',
  },
  { title: 'Help with integrations', value: 'hiw_integrations' },
];

export const TECHNICAL_OPTIONS = [
  {
    title: 'Workspace issues (video limits, inviting members)',
    value: 'ti_workspace_issues',
  },
  { title: "I can't find my videos", value: 'ti_cant_find_videos' },
  {
    title: "I'm having trouble installing Loom",
    value: 'ti_installing_loom',
  },
  {
    title: "I can't record / the recording is crashing",
    value: 'ti_crashing',
  },
  { title: "I can't download my video", value: 'ti_download_issues' },
  {
    title: "My video won't upload / I can't watch my video",
    value: 'ti_processing_issues',
  },
  {
    title: "I'm having microphone and/or camera issues",
    value: 'ti_mic_cam_issues',
  },
  {
    title: 'I need to report a bug / feature is not working correctly',
    value: 'ti_bug',
  },
  { title: "I'm getting an error message", value: 'ti_error_message' },
  { title: "Can't access my account", value: 'ti_cant_access_account' },
];

export const ACCOUNT_OPTIONS = [
  { title: 'Upgrading my subscription', value: 'am_upgrade' },
  { title: 'Extending my trial', value: 'am_extending_my_trial' },
  {
    title: 'Merging accounts or transferring videos',
    value: 'am_merge_transfer',
  },
  {
    title:
      'Updating account details, changing email, resetting password, etc...',
    value: 'am_update',
  },
  { title: "Can't access my account", value: 'am_cant_access_account' },
  { title: 'Deleting my account', value: 'am_delete_account' },
];

export const BILLING_OPTIONS = [
  { title: 'Upgrading my account', value: 'bp_upgrade' },
  {
    title: 'Downgrading or cancelling my account',
    value: 'bp_downgrade',
  },
  { title: 'Billing or payment problem', value: 'bp_payment_issues' },
  { title: 'Extending my trial', value: 'bp_trial_extension' },
  { title: 'Update invoice', value: 'update_invoice' },
  { title: 'Requesting a refund', value: 'bp_refund_request' },
];

export const PLATFORM_OPTIONS = [
  { title: 'My Video Dashboard', value: 'my_video_dashboard' },
  { title: 'Chrome Extension', value: 'chrome_extension' },
  {
    title: 'Desktop Application (Windows)',
    value: 'desktop_application__windows_',
  },
  {
    title: 'Desktop Application (Mac)',
    value: 'desktop_application__mac_',
  },
  { title: 'Mobile application', value: 'ios_app' },
];

export const CATEGORY_ISSUES_MAP = {
  [TICKET_CATEGORIES.GENERAL]: GENERAL_OPTIONS,
  [TICKET_CATEGORIES.TECHNICAL]: TECHNICAL_OPTIONS,
  [TICKET_CATEGORIES.ACCOUNT]: ACCOUNT_OPTIONS,
  [TICKET_CATEGORIES.BILLING]: BILLING_OPTIONS,
};
